<template>
  <div class='warehouseLogistics cus-obj' v-loading='loading'>
    <div class='obj-Tab'>
      <Tabs :value='warehouseLogisticsLabel' @on-click='warehouseLogisticsLabel = $event'>
        <TabPane v-for='(item, index) of warehouseLogisticsLabelList' :key='index' :label='item.label'
                 :name='item.value'></TabPane>
      </Tabs>
    </div>
    <div class='pd-tp-5'>
      <!--寻仓寻物流-->
      <div v-if="warehouseLogisticsLabel === 'warehouseLogistics'">
        <div class='obj-btn mg-bt-6'>
          <OmsButton :btn-config='btnConfig1' />
        </div>
        <div class='obj-main'>
          <Collapse value='1'>
            <Panel name='1'>
              {{ t('基本信息') }}
              <div slot='content' class=' pd-bt-10'>
                <baseInformation :baseInfoData='baseInfoData'></baseInformation>
              </div>
            </Panel>
          </Collapse>
          <row class='form-table-box '>
            <Col span='12' class='pd-rt-5'>
              <div class='flex align-items-center'>
                <OmsForm class='leftForm' :form-config='formConfig' />
                <!-- 查询 -->
                <Button style='margin-top: 10px' type='primary' @click='leftTableDataQuery'>{{t('查询')}}</Button>
              </div>

              <OmsTable
                :jordan-table-config='tableConfig'
              />
            </Col>
            <Col span='12' class='pd-lf-5'>
              <OmsForm :form-config='formConfig2' />
              <OmsTable
                :jordan-table-config='tableConfig2'
              />
            </Col>

          </row>
        </div>
      </div>
      <!--占单结果查询-->
      <div v-if="warehouseLogisticsLabel === 'accountResult'">
        <div class='obj-btn mg-bt-6'>
          <OmsButton :btn-config='btnConfig2' />
        </div>
        <div class='obj-main'>
          <Collapse value='1'>
            <Panel name='1'>
              {{ t('基本信息') }}
              <div slot='content' class=' pd-bt-10'>
                <baseInformation :baseInfoData='baseInfoData'></baseInformation>
              </div>
            </Panel>
          </Collapse>
          <div class=' '>
            <!--            <OmsTable
                          :jordan-table-config='tableConfig3'
                          @on-row-dblclick='onRowDblclick2'
                        />-->
            <Table ref='table1' border
                   @on-row-dblclick='onRowDblclick2'
                   :row-class-name='rowClassName'
                   :columns='tableConfig3.columns'
                   :height='tableConfig3.height'
                   :data='tableConfig3.data'>
              <template slot-scope='{ row, index }' slot='PRODUCE_DATE'>
                <Input v-model='row.PRODUCE_DATE' @on-change='dateChangeFun($event,index)' type='text'
                            class='product-data-style'></Input>
              </template>
            </Table>
          </div>
        </div>
      </div>
      <!-- 逻辑占单明细 -->
      <div v-if="warehouseLogisticsLabel === 'V_RPT_SG_B_STO_OUT_ITEM_VIEW'">
        <OmsTable
          :jordan-table-config='jordanTableConfig'
          @on-page-change='pageChange'
          @on-page-size-change='pageSizeChange'
        />
      </div>
    </div>

    <!-- 公共弹框 -->
    <OmsDialog :batch-closed='publicBouncedConfig.batchClosed'
               :closable='publicBouncedConfig.closable'
               :component-data='publicBouncedConfig.componentData'
               :draggable='publicBouncedConfig.draggable'
               :exclude-string='publicBouncedConfig.excludeString'
               :keep-alive='publicBouncedConfig.keepAlive'
               :mask='publicBouncedConfig.mask'
               :mask-closable='publicBouncedConfig.maskClosable'
               :name='publicBouncedConfig.name'
               :quit='publicBouncedConfig.quit'
               :scrollable='publicBouncedConfig.scrollable'
               :title='publicBouncedConfig.title'
               :title-align='publicBouncedConfig.titleAlign'
               :transfer='publicBouncedConfig.transfer'
               :url='publicBouncedConfig.url'
               :width='publicBouncedConfig.width' />

  </div>
</template>

<script>
import DialogConfig from 'burgeonConfig/config/dialogs.config';
import baseInformation from '@/views/modal/orderCenter/warehouseLogistics/baseInformation';

export default {
  components: {
    baseInformation
  },
  props: {
    componentData: {}
  },
  data() {
    return {
      canReOrder: false, // 是否可以重新占单
      loading: false,
      dialogs: DialogConfig.config(),
      publicBouncedConfig: {},
      curPsCProId: [],
      formConfig: {
        formData: [
          {
            style: 'dropSelect',
            width: '24',
            itemdata: {
              colid: 1700831993,
              colname: 'CP_C_STORE_ID',
              display: 'text',
              fkdisplay: 'drp',
              inputname: 'CP_C_STORE_ID:ENAME',
              isfk: true,
              isnotnull: true,
              name: t('仓库'), // '仓库',
              readonly: false,
              valuedata: ''
            },
            oneObj: (val) => {
              this.formConfig.formValue.storeId = val.pid;
              this.formConfig.formValue.storeName = val.valuedata;
            }
          }
        ],
        formValue: {
          storeId: '', // 仓库 id
          storeName: '' // 仓库 nem
        }
      },
      tableConfig: {
        indexColumn: true,
        isShowSelection: false,
        columns: [
          {
            title: t('SPU编码'),
            key: 'PS_C_PRO_ECODE'
          },
          {
            title: t('SPU名称'),
            key: 'PS_C_PRO_ENAME'
          },
          {
            title: t('销售数量'),
            key: 'QTY'
          },
          {
            title: t('在库量'),
            key: 'QTY_STORAGE'
          },
          {
            title: t('占用库存'),
            key: 'QTY_UNSHARED_PREOUT',
            render: (h, params) => {
              return h('a', {
                on: {
                  click: () => {
                    this.curPsCProId = [params.row.PS_C_PRO_ID];
                    this.jordanTableConfig.current = 1;
                    this.jordanTableConfig.pageSize = 100;
                    this.jordanTableConfig.data = [];
                    this.jordanTableConfig.total = 0;
                    this.getStoOutDetail();
                    this.warehouseLogisticsLabel = 'V_RPT_SG_B_STO_OUT_ITEM_VIEW';
                  }
                }
              }, params.row.QTY_UNSHARED_PREOUT);
            }
          },
          {
            title: t('可用库存'), // 可用库存
            key: 'QTY_AVAILABLE'
          },
          {
            title: t('差异量'),
            key: 'QTY_DIFF'
          },
          {
            title: t('生产日期范围'),
            key: 'EXPIRY_DATE_RANGE'
          }
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '260', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        current: 1,
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10 // 每页条数
      },
      formConfig2: {
        formData: [
          {
            style: 'dropSelect',
            width: '12',
            itemdata: {
              colid: 166813,
              colname: 'CP_C_PHY_WAREHOUSE_ID',
              display: 'text',
              fkdisplay: 'drp',
              inputname: 'CP_C_PHY_WAREHOUSE_ID:ENAME',
              isfk: true,
              isnotnull: true,
              name: t('仓库'), // '仓库',
              readonly: false,
              isBackRowItem: true,
              valuedata: ''
            },
            oneObj: (val) => {
              let ID = '', ECODE = '';
              if (val.ID) { // 下拉选中、模糊搜索
                ID = val.ID;
                ECODE = val.rowItem.ECODE.val;
              } else if (!val.length) { // clear
                // ''
              }
              this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ID = ID;
              this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ECODE = ECODE;
            }
          },
          {
            style: 'dropSelect',
            width: '12',
            // version: '1.3',
            itemdata: {
              colid: 1700842295,
              colname: 'CP_C_LOGISTICS_ID', // 当前字段的名称
              display: 'text', // 显示什么类型，例如xml表示弹窗多选加导入功能，mrp表示下拉多选
              fkdisplay: 'drp', // 外键关联类型
              inputname: 'CP_C_LOGISTICS_ID:ENAME', // 这个是做中文类型的模糊查询字段，例如ENAME
              isfk: true, // 是否有fk键
              isnotnull: true, // 是否必填
              name: t('物流公司'), // 物流公司
              readonly: false, // 是否可编辑，对应input   readonly属性
              isBackRowItem: true,
              pid: '',
              valuedata: '' // 这个是选择的值
            },
            oneObj: (val) => {
              let ID = '', ECODE = '', ENAME = '';
              if (val.ID) { // 下拉选中、模糊搜索
                ID = val.ID;
                ECODE = val.rowItem.ECODE.val;
                ENAME = val.rowItem.ENAME.val;
              } else if (!val.length) { // clear
                // ''
              }
              this.formConfig2.formValue.CP_C_LOGISTICS_ECODE = ECODE;
              this.formConfig2.formValue.CP_C_LOGISTICS_ID = ID;
              this.formConfig2.formValue.CP_C_LOGISTICS_ENAME = ENAME;
            }
          }
        ],
        formValue: {
          CP_C_PHY_WAREHOUSE_ECODE: '', // 仓库名称 code
          CP_C_PHY_WAREHOUSE_ID: '', // 仓库名称 id
          CP_C_LOGISTICS_ECODE: '', // 物流公司 code
          CP_C_LOGISTICS_ENAME: '', // 物流公司 ename
          CP_C_LOGISTICS_ID: '' // 物流公司 id
        }
      },
      tableConfig2: {
        indexColumn: false,
        isShowSelection: false,
        columns: [
          {
            title: ' ', // 操作
            key: 'action',
            fixed: 'left',
            render: (h, params) => {
              const _this = this;
              return h('Checkbox', {
                props: {
                  value: params.row.isActive,
                  circle: true
                },
                on: {
                  'on-change': (e) => {
                    const tableConfig2Data = JSON.parse(JSON.stringify(this.tableConfig2.data));
                    tableConfig2Data.map((item, index) => {
                      item.isActive = params.index === index && e; // 只能选中一个
                    });
                    this.tableConfig2.data = [];
                    this.tableConfig2.data = tableConfig2Data;

                    this.formConfig2.formData[0].itemdata.valuedata = e ? params.row.CP_C_PHY_WAREHOUSE_ENAME : '';
                    this.formConfig2.formData[0].itemdata.pid = e ? params.row.CP_C_PHY_WAREHOUSE_ID : '';
                    this.formConfig2.formData[1].itemdata.valuedata = e ? params.row.CP_C_LOGISTICS_ENAME : '';
                    this.formConfig2.formData[1].itemdata.pid = e ? params.row.CP_C_LOGISTICS_ID : '';

                    this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ID = e ? params.row.CP_C_PHY_WAREHOUSE_ID : '';
                    this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ECODE = e ? params.row.CP_C_PHY_WAREHOUSE_ECODE : '';
                    this.formConfig2.formValue.CP_C_LOGISTICS_ECODE = e ? params.row.CP_C_LOGISTICS_ECODE : '';
                    this.formConfig2.formValue.CP_C_LOGISTICS_ID = e ? params.row.CP_C_LOGISTICS_ID : '';
                    this.formConfig2.formValue.CP_C_LOGISTICS_ENAME = e ? params.row.CP_C_LOGISTICS_ENAME : '';

                  }
                }
              });
            }
          },
          {
            title: t('序号'),
            key: 'index',
            align: 'left',
            fixed: 'left',
            width: 40,
            // renderHeader: (h, params) => h("div","序号"),
            render: (h, params) =>
              h(
                'span', {
                  style: {
                    color: '#0f8ee9',
                  },
                },
                params.index + 1
              ),
          },
          {
            title: t('仓库名称'), // 仓库名称
            key: 'CP_C_PHY_WAREHOUSE_ENAME'
          },
          {
            title: t('物流公司'), // 物流公司
            key: 'CP_C_LOGISTICS_ENAME'
          },
          {
            title: t('到货天数'),
            key: 'ARRIVAL_DAYS'
          },
          {
            title: t('零担费用'),
            key: 'UNFULLCAR_COST'
          },
          {
            title: t('调拨费用'),
            key: 'TRANSFER_COST'
          },
          {
            title: t('总费用'),
            key: 'TOTAL_COST'
          }
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '260', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        current: 1,
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10 // 每页条数
      },
      tableConfig3: {
        indexColumn: true,
        isShowSelection: false,
        columns: [
          {
            title: t('序号'),
            type: 'index',
            width: 60,
            align: 'center'
          },
          {
            title: t('逻辑占用单号'),
            key: 'BILL_NO'
          },
          {
            title: t('仓库'), // '仓库'
            key: 'CP_C_STORE_ENAME'
          },
          {
            title: t('SPU编码'),
            key: 'PS_C_PRO_ECODE'
          },
          {
            title: t('SPU名称'),
            key: 'PS_C_PRO_ENAME'
          },
          // {
          //   title: '销售数量',
          //   key: 'QTY'
          // },
          {
            title: t('生产日期'),
            slot: 'PRODUCE_DATE'
          },
          {
            title: t('占用数量'),
            width: 100,
            key: 'QTY_PREOUT',
            render: (h, params) =>
              h('Input', {
                props: {
                  value: params.row.QTY_PREOUT
                },
                on: {
                  'on-blur': (e) => {
                    this.canReOrder = true;
                    this.tableConfig3.data[params.index].QTY_PREOUT = e.target.value || '';
                  }
                }
              })
          }
        ],
        data: [],
        pageShow: false, // 控制分页是否显示
        btnsShow: false, // 控制操作按钮是否显示
        searchInputShow: false, // 控制搜索框是否显示
        width: '', // 表格宽度
        height: '325', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        current: 1,
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 10 // 每页条数
      },
      jordanTableConfig: {
        isSearchText: true, // 是否修改搜索框为select
        isShowDeleteDetailBtn: false, // 控制是否显示删除明细
        isShowAddDetailBtn: false, // 控制是否显示新增明细
        searchSelectList: [], // isSearchText为false的情况下使用 搜索框list
        pageShow: true, // 控制分页是否显示
        searchInputShow: false, // 控制搜索框是否显示
        // width: '700', // 表格宽度
        height: '470', // 表格高度
        border: true, // 是否显示纵向边框
        total: 0, // 设置总条数
        pageSizeOpts: [10, 20, 30, 50, 100], // 每页条数切换的配置
        pageSize: 100, // 默认每页条数100条，产品要求
        current: 1, // 页码
        totalData: [],
        selectionData: [],
        deleteData: [], // 暂存删除的数据，调保存的时候传给后端
        addData: [], // 暂存添加的数据，调保存的时候传给后端
        updateData: [], // 暂存修改的数据，调保存的时候传给后端
        data: [],
        isShowSelection: false, // 是否展示select框
        indexColumn: true, // 是否展示序号列
        columns: [],
        loading: false
      },
      baseInfoList: [
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: `${t('平台单号')}:` // 平台单号
        },
        {
          column: 'CP_C_SHOP_TITLE',
          span: 6,
          label: `${t('下单店铺')}:` // 下单店铺
        },
        {
          column: 'CP_C_REGION_PROVINCE_ENAME',
          span: 6,
          label: `${t('收货人省份')}:` // 收货人省份
        },
        {
          column: 'CP_C_REGION_CITY_ENAME',
          span: 6,
          label: t('收货人城市')+':' // 收货人城市
        },
        {
          column: 'CP_C_REGION_AREA_ENAME',
          span: 6,
          label: t(`收货人区县`)+':' // 收货人区县
        },
        {
          column: 'RECEIVER_ADDRESS',
          span: 6,
          label: `${t('收货人地址')}:` // 收货人地址
        },
        {
          column: 'SELLER_MEMO',
          span: 12,
          label: `${t('卖家备注')}:` // 卖家备注
        }
      ],
      baseInfoData: {},
      baseInfoList2: [
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: `${t('平台单号')}:` // 平台单号
        },
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: `${t('下单店铺')}:` // 下单店铺
        },
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: `${t('收货人省份')}:` // 收货人省份
        },
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: t('收货人城市')+':' // 收货人城市
        },
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: t(`收货人区县`)+':' // 收货人区县
        },
        {
          column: 'SOURCE_CODE',
          span: 6,
          label: `${t('收货人地址')}:` // 收货人地址
        },
        {
          column: 'SOURCE_CODE',
          span: 12,
          label: `${t('卖家备注')}:` // 卖家备注
        }
      ],
      baseInfoData2: {
        SOURCE_CODE: 123
      },
      warehouseLogisticsLabel: 'warehouseLogistics',
      warehouseLogisticsLabelList: [
        {
          label: t('寻仓寻物流'),
          value: 'warehouseLogistics'
        },
        {
          label: t('占单结果查询'),
          value: 'accountResult'
        },
        {
          label: t('逻辑占用明细'),
          value: 'V_RPT_SG_B_STO_OUT_ITEM_VIEW'
        }
      ],
      btnConfig1: {
        typeAll: 'default', // 按钮统一风格样式
        loading: false, // 按钮加载
        buttons: [
          {
            text: t('确定'), // 确认
            type: '',
            webname: 'queryList',
            btnclick: () => {
              if (this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ID && this.formConfig2.formValue.CP_C_LOGISTICS_ENAME) {
                this.omsConfirmFun({
                  confirmType: 1,
                  cpCLogisticsEname: this.formConfig2.formValue.CP_C_LOGISTICS_ENAME,
                  cpCLogisticsEcode: this.formConfig2.formValue.CP_C_LOGISTICS_ECODE,
                  cpCLogisticsId: this.formConfig2.formValue.CP_C_LOGISTICS_ID,
                  cpCPhyWarehouseId: this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ID,
                  cpCPhyWarehouseCode: this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ECODE
                }).then(() => {
                  this.formConfig2.formValue.CP_C_LOGISTICS_ECODE = '';
                  this.formConfig2.formValue.CP_C_LOGISTICS_ID = '';
                  this.formConfig2.formValue.CP_C_LOGISTICS_ENAME = '';
                  this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ID = '';
                  this.formConfig2.formValue.CP_C_PHY_WAREHOUSE_ECODE = '';

                  this.formConfig2.formData[0].itemdata.valuedata = '';
                  this.formConfig2.formData[0].itemdata.pid = '';
                  this.formConfig2.formData[1].itemdata.valuedata = '';
                  this.formConfig2.formData[1].itemdata.pid = '';

                  this.tableConfig2.data.map((item, index) => {
                    item.isActive = false; // 全部取消勾选
                  });
                });
              } else {
                $fcWarn({
                  title: t('提示'), // 提示
                  content: t('物流或仓库不能为空')
                });
              }

            } // 按钮点击事件
          },
          {
            type: '',
            text: t('刷新'), // 刷新
            btnclick: () => {
              this.formConfig.formData[0].itemdata.valuedata = '';
              this.formConfig.formData[0].itemdata.pid = '';
              this.formConfig.formValue.storeName = '';
              this.formConfig.formValue.storeId = '';
              this.leftTableDataQuery();
              this.mainDataQuery();
            } // 按钮点击事件
          },
          {
            type: '',
            text: t('返回'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            } // 按钮点击事件
          }
        ]
      },
      btnConfig2: {
        typeAll: 'default', // 按钮统一风格样式
        loading: false, // 按钮加载
        buttons: [
          {
            text: t('重新占单'),
            type: '',
            webname: 'queryList',
            btnclick: () => {
              this.omsConfirmFun({
                confirmType: 2
              });
            } // 按钮点击事件
          },
          {
            type: '',
            text: t('刷新'), // 刷新
            btnclick: () => {
              this.occupyResultQuery();
            } // 按钮点击事件
          },
          {
            type: '',
            text: t('返回'),
            btnclick: () => {
              this.$parent.$parent.closeConfirm();
            } // 按钮点击事件
          }
        ]
      }
    };
  },
  computed: {},
  mounted() {
    this.baseInfoData = this.componentData.data.mainTableResult || {}; // 主表数据
    this.tableConfig2.data = this.componentData.data.itemTableResultList || []; // 右侧表格数据
    this.tableConfig3.data = this.componentData.data.stoOutInfoResultList || []; // Tab:占单结果查询 的初始数据
    // this.mainDataQuery();
    // this.leftTableDataQuery();
    // this.occupyResultQuery();
  },
  methods: {
    /**
     * 占单结果查询 - 生产日期修改事件
     * @param $event
     * @param index
     */
    dateChangeFun($event, index) {
      console.log('dateChangeFun::', $event);
      this.tableConfig3.data[index] = { ...this.tableConfig3.data[index], PRODUCE_DATE: $event.target.value }
      // this.tableConfig3.data[index].PRODUCE_DATE = $event.target.value;
      this.canReOrder = true;
    },
    /**
     * 高亮 class
     * @param row
     * @param index
     * @returns {string}
     */
    rowClassName(row, index) {
      if (row.OVER_LIMIT) {
        return 'bg-pink';
      }
      return '';
    },
    /**
     * 动作定义按钮接口
     * @param params
     * @returns {Promise<{}>}
     */
    async omsConfirmFun(paramObj) {
      const params = {
        stoOutInfoResultList: [],
        ...paramObj
      };
      let data = {};
      if (params.confirmType === 2) {
        if (!this.canReOrder) {
          $fcWarn({
            title: t('提示'), // 提示
            content: t('暂无可提交数据')
          });
          return false;
        }
        for (let i = 1; i < this.tableConfig3.data.length; i++) {
          const item = this.tableConfig3.data[i];
          if (item.PRODUCE_DATE === '') {
            $fcWarn({
              title: t('提示'), // 提示
              content: t('生产日期不可为空！')
            });
            return false;
          } else if (item.QTY_PREOUT === '') {
            $fcWarn({
              title: t('提示'), // 提示
              content: t('占用数量不可为空！')
            });
            return false;
          }
        }
        params.stoOutInfoResultList = this.tableConfig3.data;
        params.stoOutInfoResultList.map(item => item.PRODUCE_DATE = item.PRODUCE_DATE.replace(/\-/g, ''));
      }
      this.loading = true;
      await this.service.orderCenter.omsConfirm({ id: this.$route.params.customizedModuleId, ...params }).then(res => {
        if (res.data.code === 0) {
          data = res.data;
          $fcSuccess({
            content: res.data.message
          });
        } else {
          $fcError(res.data.message);
        }
        this.canReOrder = false;
        this.loading = false;
      }).finally(() => {
        this.loading = false;
        if (paramObj.confirmType === 2) {
          this.mainDataQuery();
        }
      });
      return data;
    },
    /**
     * 主表数据请求
     */
    mainDataQuery() {
      this.omsQueryDataFun({ queryType: 1 }).then((res) => {
        this.baseInfoData = res.mainTableResult; // 主表数据
        this.tableConfig2.data = res.itemTableResultList || []; // 右侧表格数据
        this.tableConfig3.data = res.stoOutInfoResultList || []; // Tab:占单结果查询 的初始数据
      });
    },
    /**
     * 左侧表格数据请求
     */
    leftTableDataQuery() {
      const params = {
        queryType: 2
      };
      if (this.formConfig.formValue.storeId !== '') {
        params.storeId = this.formConfig.formValue.storeId;
      } else {
        this.tableConfig.data = [];
        return;
      }
      this.tableConfig.storeObj = {
        storeId: this.formConfig.formValue.storeId,
        storeName: this.formConfig.formValue.storeName
      }; //存一下查询的仓库数据，双击跳转时候用

      this.tableConfig.storeName = params.storeId; //存一下storeId，双击跳转时候用
      this.omsQueryDataFun(params).then((res) => {
        this.tableConfig.data = res.storageInfoResultList;
      });
    },
    /**
     * 占用结果子表查询
     */
    occupyResultQuery() {
      this.omsQueryDataFun({ id: this.$route.params.customizedModuleId, queryType: 3 }).then((res) => {
        this.tableConfig3.data = res.stoOutInfoResultList || [];
      });
    },
    async omsQueryDataFun(params) {
      this.loading = true;
      let omsQueryData = [];
      await this.service.orderCenter.omsQueryData({ id: this.$route.params.customizedModuleId, ...params }).then(res => {
        if (res.data.code == 0) {
          omsQueryData = res.data.data;
        } else {
          $fcError(res.data.message);
        }
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
      return omsQueryData;
    },
    /**
     * 寻仓寻物流 左侧表格双击事件
     * @param row
     */
    onRowDblclick(row) {
      const storeObj = this.tableConfig.storeObj;
      // 跳转到：逻辑占用明细查询
      R3.store.commit('global/tabOpen', {
        type: 'S',
        tableName: 'V_RPT_SG_B_STO_OUT_ITEM_VIEW',
        tableId: '249231457',
        isSetQuery: true,
        queryData: {
          tableId: '249231457',
          values: [
            //逻辑仓
            {
              display: 'OBJ_FK',
              colid: '1700841435',
              defaultValue: storeObj.storeName,
              refobjid: [storeObj.storeId]
            },
            //SPU编码
            {
              display: 'OBJ_FK',
              colid: '1700841436',
              defaultValue: row.PS_C_PRO_ENAME,
              refobjid: [row.PS_C_PRO_ECODE]
            }
          ]
        }
      });
      this.$parent.$parent.closeConfirm();
    },
    /**
     * 占单结果查询 表格双击事件
     * @param row
     */
    onRowDblclick2(row) {
      R3.store.commit('global/tabCloseAppoint', {
        routeFullPath: '/SYSTEM/TABLE/SG_B_STORAGE/24610',
        stopRouterPush: false,
        keepAliveModuleName: 'S.SG_B_STORAGE.24610',
        tableName: 'SG_B_STORAGE'
      });
      setTimeout(() => {
        // 跳转到：逻辑仓批次库存查询
        R3.store.commit('global/tabOpen', {
          type: 'S',
          tableName: 'SG_B_STORAGE',
          tableId: '24610',
          isSetQuery: true,
          queryData: {
            tableId: '24610',
            values: [
              //逻辑仓
              {
                display: 'OBJ_FK',
                colid: '168724',
                defaultValue: row.CP_C_STORE_ENAME,
                refobjid: [row.CP_C_STORE_ID]
              },
              //SPU编码
              {
                display: 'text',
                colid: '174551',
                defaultValue: row.PS_C_PRO_ECODE,
                refobjid: [row.PS_C_PRO_ECODE]
              }
            ]
          }
        });
      }, 0);
      this.$parent.$parent.closeConfirm();
    },
    fnchange(v) {
      this.tableConfig.current = v;
    },
    fnSize(v) {
      this.tableConfig.pageSize = v;
    },

    /**
     * 寻仓寻物流 - 弹窗里的tabs
     * @param item
     */
    warehouseLogisticslabelClick(item) {
      this.warehouseLogisticsLabel = item.value;
    },
    // 查询逻辑占用明细
    getStoOutDetail() {
      const { pageSize, pageIndex } = this.jordanTableConfig;
      this.jordanTableConfig.loading = true;
      const query = {
        table: 'V_RPT_SG_B_STO_OUT_ITEM_VIEW',
        startindex: (this.jordanTableConfig.current - 1) * this.jordanTableConfig.pageSize, // 起始下标
        range: pageSize,
        fixedcolumns: {
          CP_C_STORE_ID: [this.formConfig.formValue.storeId],
          PS_C_PRO_ID: this.curPsCProId
        },
        column_include_uicontroller: true,
        isolr: false
      };
      const formData = new FormData();
      formData.append('searchdata', JSON.stringify(query));
      this.service.common.QueryList(formData)
        .then(({ data: { code, datas, message } }) => {
          if (code == 0) {
            const { row, totalRowCount, tabth } = datas;
            this.jordanTableConfig.data = row.map(i => {
              let row = {};
              for (let key in i) {
                row[key] = i[key].val;
              }
              return row;
            });
            this.jordanTableConfig.total = totalRowCount;
            const columns = tabth.map(i => ({ title: i.name, key: i.colname }));
            this.jordanTableConfig.columns = columns;
          }
        }).finally(() => {
        this.jordanTableConfig.loading = false;
      });
    },
    pageChange(val) {
      this.jordanTableConfig.current = val;
      this.getStoOutDetail();
    },
    pageSizeChange(val) {
      this.jordanTableConfig.pageSize = val;
      this.getStoOutDetail();
    }
  }
};
</script>

<style lang='scss'>
.warehouseLogistics {
  .product-data-style {
    width: 120px;

    .ark-input-innerWrap {
      top: 50%;
      transform: translateY(-50%);
    }
  }

  .bg-pink td {
    background-color: #FA919E;
  }

  .leftForm {
    width: 240px;
  }

  .ark-tabs-bar {
    margin-bottom: 0;
  }

  .ark-tabs-tab {
    line-height: unset;
    height: 32px;
    padding: 0 10px;

  }

  &.cus-obj .obj-btn {
    padding-left: 0;
    padding-right: 0;
    box-shadow: unset;
  }

  .ark-collapse {
    margin-left: 0 !important;
    margin-right: 0 !important;;
  }

  .text-ellipsis {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .form-table-box {
    .ark-col:first-child {
      @labelWidth: 50px!important;
      .ark-form-item-label {
        width: @labelWidth;
      }

      .ark-form-item-content {
        margin-left: @labelWidth;
      }
    }

    .business-form-main .cusForm-content.noFlod {
      padding: 0;
    }
  }
}
</style>
